<template>
  <div class="d-flex align-center text-right cursor-help">
    <v-menu
      v-for="letra in arvore_decisao"
      :key="letra"
      open-on-hover
      :close-on-content-click="false"
      bottom
      left
      offset-y
      :open-delay="250"
    >
      <template v-slot:activator="{on, attrs}">
        <div
          v-bind="attrs" v-on="on"
          class="retangulo-25-por-13 borda-retangulo ml-1"
          :class="{
            'bg-red': niveis_curvas.elevado.includes(letra),
            'bg-yellow': niveis_curvas.intermediario.includes(letra),
            'bg-green': niveis_curvas.baixo.includes(letra),
          }"
        />
      </template>

      <div class="bg-white pt-1 w-550 pb-1">
        <div v-if="['A', 'B', 'C'].includes(letra)" class="px-2">
          <p class="ma-0 font-15 font-weight-medium">Custo de Aquisição</p>
          <p class="ma-0 mt-n1 font-12">Classificação voltada para área econômica, que visa segmentar de formas distintas a importância da aquisição de um determinado SKU, frente a seu custo de aquisição</p>
        </div>

        <div v-if="['Z', 'Y', 'X'].includes(letra)" class="px-2">
          <p class="ma-0 font-15 font-weight-medium">Criticidade de Resultado</p>
          <p class="ma-0 mt-n1 font-12">Classificação voltada para o resultado comercial, que visa segmentar de formas distintas a importância comercial de um determinado SKU, frente ao faturamento geral</p>
        </div>

        <div v-if="['1', '2', '3'].includes(letra)" class="px-2">
          <p class="ma-0 font-15 font-weight-medium">Comprabilidade</p>
          <p class="ma-0 mt-n1 font-12">Classificação diz respeito ao processo de aquisição dos itens em estoque, incluindo tanto a identificação, qualificação e desenvolvimento de fornecedores como o disparo e atendimento de requisições, em termos do grau de confiabilidade das especificações e prazos</p>
        </div>

        <div v-if="['P', 'Q', 'R'].includes(letra)" class="px-2">
          <p class="ma-0 font-15 font-weight-medium">Frequência de Saída</p>
          <p class="ma-0 mt-n1 font-12">Classificação diz respeito a frequência de ocorrências de apanhes (pickings) envolvendo determinada SKU, observadas de um período pré-determinado, independentemente da quantidade envolvida em cada transação</p>
        </div>

        <v-divider class="mt-1 mb-1" />

        <div class="pl-1">
          <div class="d-flex align-center">
            <div class="retangulo-25-por-13 borda-retangulo ml-1 bg-red" />
            <span class="font-13 ml-1">Nível Elevado</span>
          </div>

          <div class="d-flex align-center">
            <div class="retangulo-25-por-13 borda-retangulo ml-1 bg-yellow" />
            <span class="font-13 ml-1">Nível Intermediário</span>
          </div>

          <div class="d-flex align-center">
            <div class="retangulo-25-por-13 borda-retangulo ml-1 bg-green" />
            <span class="font-13 ml-1">Nível Baixo</span>
          </div>
        </div>
      </div>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "CoresCurvas",
  props: {
    arvore_decisao: String
  },
  data: () => ({
    niveis_curvas: {
      elevado: ['A', 'Z', '1', 'P'],
      intermediario: ['B', 'Y', '2', 'Q'],
      baixo: ['C', 'X', '3', 'R']
    }
  })
}
</script>

<style scoped>
.borda-retangulo {
  border: 1px solid #f2f2f2;
}
</style>
